import { ThreadStateEnum } from '@anecdotes/commenting';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject, DestroyRef } from '@angular/core';

import { CommentingFacadeService, CommentPanelManagerService, ConfirmationModalService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-delete-all-action',
  templateUrl: './delete-all-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAllActionComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @Input()
  isDisabled = false;

  resolvedCommentsExist: boolean;

  constructor(
    private commentingFacadeService: CommentingFacadeService,
    private commentPanelManagerService: CommentPanelManagerService,
    private confirmationModalService: ConfirmationModalService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.commentPanelManagerService
      .getCommentingResources()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((threadViewModels) => {
        this.resolvedCommentsExist = !threadViewModels.some((thread) => thread.threadState === ThreadStateEnum.Resolved);
        this.cd.detectChanges();
      });
  }

  async deleteAll(): Promise<void> {
    if (await this.confirmationModalService.openDeleteAllConfirmation()) {
      await this.commentingFacadeService.deleteAllResolvedThreads();
    }
  }
}
